import { InputProps } from "../Input/input.props";
import AGInput from "../Input";
import { useState } from "react";
import { formatCurrency, isNumber } from "../../utils/helper";

const AGCurrencyInput: React.FC<InputProps> = ({
  maxLength,
  value,
  placeholder,
  type,
  accept,
  ref,
  onChange,
  onFocus,
  onBlur,
  ...props
}) => {
  const [currencyInputString, setCurrencyInputString] = useState(
    (value !== undefined || value !== null || value !== "") && !isNumber(value!) ? "" : formatCurrency(value!).slice(1),
  );

  const handleFeeInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setState: (value: any) => void,
  ) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/[^0-9.]/g, "");
    const parts = inputValue.split('.');

    // Make sure user can just input to 2 decimal number
    if (parts.length > 1) {
      parts[1] = parts[1].substring(0, 2);
      inputValue = parts.join('.');
    }

    // Ensure there is only one decimal point
    const dotCount = (inputValue.match(/\./g) || []).length;
    if (dotCount > 1) {
      // Keep everything up to the first dot
      inputValue = inputValue.substring(0, inputValue.indexOf(".") + 1) + inputValue.slice(inputValue.indexOf(".") + 1).replace(/\./g, "");
    }
    if (inputValue.startsWith(".")) {
      setState("");
      return;
    }

    setState(inputValue);
  };

  return (
    <AGInput
      ref={ref ? ref : undefined}
      accept={accept}
      placeholder={placeholder}
      maxLength={maxLength}
      {...props}
      onBlur={(e) => {
        if (onBlur !== undefined) {
          onBlur(e);
        }
        setCurrencyInputString(currencyInputString === "" ? "" :
          formatCurrency(
            Number(currencyInputString),
          ).slice(1),
        );
      }}
      onFocus={(e) => {
        if (onFocus !== undefined) {
          onFocus(e);
        }
        setCurrencyInputString(currencyInputString.replace(/,/g, ""));
      }}
      className="w-full !pl-[20px]"
      type="text"
      onChange={(e) => {
        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
        if (onChange !== undefined) {
          onChange(e);
        }
        handleFeeInputChange(e, setCurrencyInputString);
      }}
      value={`${currencyInputString ?? 0}`}
    />
  );
};

export default AGCurrencyInput;
